module.exports = __webpack_public_path__ + "img/wp-new-habit-card18.ada031d6.jpg";